import { render, staticRenderFns } from "./PrivatePlot.vue?vue&type=template&id=206676c4&"
import script from "./PrivatePlot.vue?vue&type=script&lang=js&"
export * from "./PrivatePlot.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports